import Cookies from 'js-cookie';

import { axiosAuthInstance, setAuthToken } from "@/common/axiosAuthInstance";
import apiCall from './apiCall';

const assignRole = async (data: any) => {
    const URL = '/Role/assign';

    try {
        const token = Cookies.get('access_token') as string;
        setAuthToken(token);
        return await axiosAuthInstance.post<any[]>(URL, data);
    } catch (err: any) {
        const obj = {
            status: err?.response?.status,
            message: err?.response?.data?.message
        }
        return obj;
    }
};

const getListRole = async (param: any) => {
    const query = `?search=${param.search}&pageNumber=${param.pageNumber}&pageSize=${param.pageSize}`;
    const URL = `/Role/GetAllRoles${query}`;
    return apiCall('get', URL);
};

const getRoleData = async () => {
    const URL = '/Role/GetDataRoles';
    return apiCall('get', URL);
};

const getRoleById = async (id: string) => {
    const URL = `/Role/GetRoleById/${id}`;
    return apiCall('get', URL);
};

const putRole = async (data: any) => {
    const URL = '/Role/Update';
    return apiCall('post', URL, data);
};

const postRole = async (data: any) => {
    const URL = '/Role/Create';
    return apiCall('post', URL, data);
};

const deleteRole = async (id: string) => {
    const URL = '/Role/Delete';
    return apiCall('post', URL, { roleId: id });
};

export {
    assignRole,
    getListRole,
    getRoleData,
    getRoleById,
    putRole,
    postRole,
    deleteRole
}
